module.exports = __webpack_public_path__ + "static/media/dropBox.1c55ba50.jpg";